import React, { Component, ReactElement, useContext, useEffect } from 'react';
import {
  Droppable,
  DroppableProvided,
  DroppableStateSnapshot,
  DropResult,
  DragStart,
  DragUpdate,
} from 'react-beautiful-dnd';
import { MMdndContext } from '../../helpers/MMdndContext';

type Props = {
  children: (
    provided: DroppableProvided,
    snapshot?: DroppableStateSnapshot,
  ) => ReactElement<
    any,
    | string
    | ((
        props: any,
      ) => ReactElement<
        any,
        string | (new (props: any) => Component<any, any, any>)
      > | null)
    | (new (props: any) => Component<any, any, any>)
  >;
  droppableId: string;
  type: string;
  direction?: 'vertical' | 'horizontal';
  onDragStart?: (start: DragStart) => void;
  onDragUpdate?: (update: DragUpdate) => void;
  onDragEnd: (result: DropResult) => void;
};

export const MMdndDroppable = ({
  children,
  droppableId,
  type,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  direction = 'vertical',
}: Props) => {
  const { subscribe } = useContext(MMdndContext);

  useEffect(() => {
    const unsubscribe = subscribe(droppableId, {
      onDragStart,
      onDragUpdate,
      onDragEnd,
    });

    return unsubscribe;
  }, [subscribe, droppableId, onDragStart, onDragUpdate, onDragEnd]);

  return (
    <Droppable droppableId={droppableId} direction={direction} type={type}>
      {provided => children(provided)}
    </Droppable>
  );
};
